module.exports = __webpack_public_path__ + "static/img/02-人大附中石景山学校.c8f6b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/02-人大附中石景山学校.png
// module id = qsKL
// module chunks = 0